// ============================================================
// VITASCANN — recettesData.js
// Données partagées des recettes santé (extraites de RecettesSante.js)
// Utilisé par RecettesSante.js ET par les modules de scan
// (ScoreEnergie, ScoreImmunite, etc.) pour suggérer une recette
// liée au résultat d'un scan.
// ============================================================

export const RECETTES = [
  {
    id: 1,
    emoji: "🥕🍊",
    ingredients: ["Carotte", "Orange"],
    titre_fr: "Vision & Antioxydants",
    titre_en: "Vision & Antioxidants",
    bienfait_fr: "Soutient la vue et apporte une grande quantité d'antioxydants protecteurs.",
    bienfait_en: "Supports vision and delivers powerful antioxidant protection.",
    detail_fr: "La bêta-carotène de la carotte + la vitamine C de l'orange forment un duo imbattable pour la santé oculaire et la neutralisation des radicaux libres.",
    detail_en: "Beta-carotene from carrot + vitamin C from orange create an unbeatable duo for eye health and free radical neutralization.",
    nutrients: ["Bêta-carotène", "Vit. C", "Vit. A"],
    categorie: "vue",
    couleur: "#f97316",
    preparation_fr: "Presser 2 carottes + 1 orange. Boire le matin à jeun.",
    preparation_en: "Juice 2 carrots + 1 orange. Drink in the morning on an empty stomach.",
    tibb_fr: "La carotte est mentionnée comme légume bénéfique dans la médecine prophétique.",
    tibb_en: "Carrots are mentioned as a beneficial vegetable in prophetic medicine.",
  },
  {
    id: 2,
    emoji: "🍏🫚",
    ingredients: ["Pomme verte", "Cannelle"],
    titre_fr: "Glycémie & Équilibre",
    titre_en: "Blood Sugar & Balance",
    bienfait_fr: "Aide à mieux réguler la glycémie et limite les pics de sucre.",
    bienfait_en: "Helps regulate blood sugar and limits sugar spikes.",
    detail_fr: "Les polyphénols de la pomme ralentissent l'absorption du sucre, tandis que la cannelle améliore la sensibilité à l'insuline.",
    detail_en: "Polyphenols in apple slow sugar absorption, while cinnamon improves insulin sensitivity.",
    nutrients: ["Polyphénols", "Fibres", "Cinnamaldéhyde"],
    categorie: "glycemie",
    couleur: "#a3e635",
    preparation_fr: "Couper une pomme verte en tranches, saupoudrer de cannelle. Consommer en collation.",
    preparation_en: "Slice a green apple, sprinkle with cinnamon. Eat as a snack.",
    tibb_fr: "La cannelle (qirfa) est recommandée par le Prophète ﷺ pour ses vertus digestives.",
    tibb_en: "Cinnamon (qirfa) is recommended by the Prophet ﷺ for its digestive benefits.",
  },
  {
    id: 3,
    emoji: "🍍🫚",
    ingredients: ["Ananas", "Gingembre"],
    titre_fr: "Digestion & Anti-ballonnement",
    titre_en: "Digestion & Anti-bloating",
    bienfait_fr: "Favorise la digestion et aide à soulager les ballonnements.",
    bienfait_en: "Promotes digestion and helps relieve bloating.",
    detail_fr: "La bromélaïne de l'ananas est une enzyme digestive puissante. Le gingembre stimule les sucs gastriques et réduit l'inflammation intestinale.",
    detail_en: "Bromelain from pineapple is a powerful digestive enzyme. Ginger stimulates gastric juices and reduces intestinal inflammation.",
    nutrients: ["Bromélaïne", "Gingérols", "Vit. B1"],
    categorie: "digestion",
    couleur: "#fbbf24",
    preparation_fr: "Mixer 2 tranches d'ananas + 1 cm de gingembre frais + 200ml d'eau. Boire après le repas.",
    preparation_en: "Blend 2 pineapple slices + 1 cm fresh ginger + 200ml water. Drink after meals.",
    tibb_fr: "Le gingembre (zanjabīl) est cité dans le Coran (76:17) et recommandé pour la digestion.",
    tibb_en: "Ginger (zanjabīl) is mentioned in the Quran (76:17) and recommended for digestion.",
  },
  {
    id: 4,
    emoji: "🌿🍋",
    ingredients: ["Épinard", "Citron"],
    titre_fr: "Fer & Anti-fatigue",
    titre_en: "Iron & Anti-fatigue",
    bienfait_fr: "Apporte du fer et aide à combattre la fatigue chronique.",
    bienfait_en: "Provides iron and helps fight chronic fatigue.",
    detail_fr: "La vitamine C du citron multiplie par 3 l'absorption du fer non-héminique des épinards. Combo essentiel contre l'anémie.",
    detail_en: "Vitamin C from lemon triples the absorption of non-heme iron from spinach. Essential combo against anemia.",
    nutrients: ["Fer", "Vit. C", "Folates", "Magnésium"],
    categorie: "energie",
    couleur: "#00ff88",
    preparation_fr: "Smoothie : 2 poignées d'épinards + jus d'1 citron + 250ml d'eau. Ne pas cuire les épinards.",
    preparation_en: "Smoothie: 2 handfuls of spinach + juice of 1 lemon + 250ml water. Do not cook the spinach.",
    tibb_fr: "La consommation de légumes verts feuillus est encouragée dans la Sunnah pour maintenir la santé.",
    tibb_en: "Consuming leafy green vegetables is encouraged in the Sunnah to maintain health.",
  },
  {
    id: 5,
    emoji: "🫜🩸",
    ingredients: ["Betterave", "Grenade"],
    titre_fr: "Circulation & Cœur",
    titre_en: "Circulation & Heart",
    bienfait_fr: "Soutient la circulation sanguine et aide à protéger le cœur.",
    bienfait_en: "Supports blood circulation and helps protect the heart.",
    detail_fr: "Les nitrates de la betterave dilatent les vaisseaux et réduisent la pression artérielle. Les polyphénols de la grenade protègent les artères.",
    detail_en: "Nitrates in beet dilate vessels and reduce blood pressure. Pomegranate polyphenols protect arteries.",
    nutrients: ["Nitrates", "Polyphénols", "Vit. B9", "Potassium"],
    categorie: "coeur",
    couleur: "#f43f5e",
    preparation_fr: "Jus : 1 betterave crue + graines d'1/2 grenade. Presser ou mixer.",
    preparation_en: "Juice: 1 raw beet + seeds from 1/2 pomegranate. Press or blend.",
    tibb_fr: "La grenade (rumman) est mentionnée 3 fois dans le Coran. Ibn Al-Qayyim la recommande pour le cœur.",
    tibb_en: "Pomegranate (rumman) is mentioned 3 times in the Quran. Ibn Al-Qayyim recommends it for the heart.",
  },
  {
    id: 6,
    emoji: "🫚🍋🥒",
    ingredients: ["Gingembre", "Citron", "Concombre"],
    titre_fr: "Anti-inflammation & Immunité",
    titre_en: "Anti-inflammation & Immunity",
    bienfait_fr: "Aide à lutter contre l'inflammation et soutient les défenses naturelles.",
    bienfait_en: "Helps fight inflammation and supports natural defenses.",
    detail_fr: "Le gingembre inhibe les cytokines pro-inflammatoires. Le citron alcalinise et apporte la vit. C. Le concombre hydrate et apporte des minéraux.",
    detail_en: "Ginger inhibits pro-inflammatory cytokines. Lemon alkalizes and provides vitamin C. Cucumber hydrates and provides minerals.",
    nutrients: ["Gingérols", "Vit. C", "Silice", "Eau"],
    categorie: "immunite",
    couleur: "#38bdf8",
    preparation_fr: "Eau détox : 500ml d'eau + 1/2 concombre en rondelles + jus de citron + 3 rondelles de gingembre. Infuser 2h au frigo.",
    preparation_en: "Detox water: 500ml water + 1/2 sliced cucumber + lemon juice + 3 ginger slices. Infuse 2h in fridge.",
    tibb_fr: "Le gingembre est décrit dans la médecine prophétique comme 'chaud et humide' — parfait pour l'hiver.",
    tibb_en: "Ginger is described in prophetic medicine as 'hot and moist' — perfect for winter.",
  },
  {
    id: 7,
    emoji: "🥒🌿",
    ingredients: ["Concombre", "Céleri"],
    titre_fr: "Drainage & Rétention d'eau",
    titre_en: "Drainage & Water Retention",
    bienfait_fr: "Favorise l'élimination de l'excès d'eau et aide contre la rétention.",
    bienfait_en: "Promotes elimination of excess water and helps against water retention.",
    detail_fr: "Le concombre (96% d'eau) et le céleri ont des propriétés diurétiques naturelles. Ils stimulent les reins sans les fatiguer.",
    detail_en: "Cucumber (96% water) and celery have natural diuretic properties. They stimulate the kidneys without tiring them.",
    nutrients: ["Eau", "Potassium", "Manganèse", "Vit. K"],
    categorie: "drainage",
    couleur: "#6ee7b7",
    preparation_fr: "Jus vert : 1 concombre + 3 branches de céleri. Presser et boire immédiatement.",
    preparation_en: "Green juice: 1 cucumber + 3 celery stalks. Press and drink immediately.",
    tibb_fr: "Le concombre (qiththāʾ) est mentionné dans un hadith où le Prophète ﷺ le consommait avec des dattes.",
    tibb_en: "Cucumber (qiththāʾ) is mentioned in a hadith where the Prophet ﷺ ate it with dates.",
  },
  {
    id: 8,
    emoji: "🫐🥛",
    ingredients: ["Myrtilles", "Lait d'amande"],
    titre_fr: "Mémoire & Cerveau",
    titre_en: "Memory & Brain",
    bienfait_fr: "Améliore la concentration et protège les cellules du cerveau.",
    bienfait_en: "Improves concentration and protects brain cells.",
    detail_fr: "Les anthocyanes des myrtilles traversent la barrière hémato-encéphalique et réduisent le stress oxydatif neuronal. La vitamine E des amandes complète.",
    detail_en: "Blueberry anthocyanins cross the blood-brain barrier and reduce neuronal oxidative stress. Almond vitamin E completes the action.",
    nutrients: ["Anthocyanes", "Vit. E", "Oméga-3", "Magnésium"],
    categorie: "cerveau",
    couleur: "#818cf8",
    preparation_fr: "Smoothie : 1 poignée de myrtilles + 250ml lait d'amande + 1 c.à.c de miel de Manuka.",
    preparation_en: "Smoothie: 1 handful blueberries + 250ml almond milk + 1 tsp Manuka honey.",
    tibb_fr: "Le miel est cité dans le Coran (16:69) comme guérison pour les hommes. Préférer le miel brut.",
    tibb_en: "Honey is cited in the Quran (16:69) as a healing for people. Prefer raw honey.",
  },
  {
    id: 9,
    emoji: "🧄🍯",
    ingredients: ["Ail", "Miel"],
    titre_fr: "Antibactérien & Immunité",
    titre_en: "Antibacterial & Immunity",
    bienfait_fr: "Puissant combo antibactérien naturel pour booster les défenses.",
    bienfait_en: "Powerful natural antibacterial combo to boost defenses.",
    detail_fr: "L'allicine de l'ail est l'un des antibiotiques naturels les plus puissants. Le miel renforce l'effet et adoucit le goût.",
    detail_en: "Allicin from garlic is one of the most powerful natural antibiotics. Honey enhances the effect and softens the taste.",
    nutrients: ["Allicine", "Peroxyde d'hydrogène", "Zinc", "Sélénium"],
    categorie: "immunite",
    couleur: "#fbbf24",
    preparation_fr: "Écraser 1 gousse d'ail, laisser reposer 10min (active l'allicine), mélanger avec 1 c.à.c de miel. Avaler le matin.",
    preparation_en: "Crush 1 garlic clove, let sit 10min (activates allicin), mix with 1 tsp honey. Take in the morning.",
    tibb_fr: "L'ail (thūm) est mentionné dans la Sunnah. Ibn Sina le recommande pour renforcer l'immunité.",
    tibb_en: "Garlic (thūm) is mentioned in the Sunnah. Ibn Sina recommends it for strengthening immunity.",
  },
  {
    id: 10,
    emoji: "🥜🍯",
    ingredients: ["Noix du Brésil", "Mélasse noire", "Graines de citrouille"],
    titre_fr: "Minéraux Naturels — Sélénium, Fer & Magnésium",
    titre_en: "Natural Minerals — Selenium, Iron & Magnesium",
    bienfait_fr: "Apporte sélénium, fer et magnésium directement par l'alimentation, sans passer par les suppléments.",
    bienfait_en: "Delivers selenium, iron and magnesium directly through food, without supplements.",
    detail_fr: "2 noix du Brésil couvrent tes besoins quotidiens en sélénium (antioxydant, thyroïde). La mélasse noire (blackstrap) est une des meilleures sources de fer naturel. Les graines de citrouille trempées libèrent leur magnésium — le trempage active leur absorption par le corps.",
    detail_en: "2 Brazil nuts cover your daily selenium needs (antioxidant, thyroid support). Blackstrap molasses is one of the best natural iron sources. Soaked pumpkin seeds release their magnesium — soaking activates their absorption by the body.",
    nutrients: ["Sélénium", "Fer", "Magnésium"],
    categorie: "mineraux",
    couleur: "#d4a574",
    preparation_fr: "Fais tremper 1 poignée de graines de citrouille dans l'eau 2-4h (active l'absorption du magnésium). Mange-les avec 2-3 noix du Brésil + 1 c. à soupe de mélasse noire diluée dans un peu d'eau tiède.",
    preparation_en: "Soak 1 handful of pumpkin seeds in water for 2-4h (activates magnesium absorption). Eat them with 2-3 Brazil nuts + 1 tbsp blackstrap molasses diluted in warm water.",
    tibb_fr: "Les fruits à coque et les graines sont valorisés dans la tradition prophétique comme sources de force et de nutrition.",
    tibb_en: "Nuts and seeds are valued in prophetic tradition as sources of strength and nutrition.",
    attention_fr: "Ne dépasse pas 3-4 noix du Brésil par jour (excès de sélénium possible).",
    attention_en: "Don't exceed 3-4 Brazil nuts per day (possible selenium excess).",
  },
  {
    id: 11,
    emoji: "🌾🍯",
    ingredients: ["Graines de lin", "Graines de sésame", "Miel"],
    titre_fr: "Smoothie Os, Mémoire & Digestion",
    titre_en: "Bones, Memory & Digestion Smoothie",
    bienfait_fr: "Renforce les os, soutient la mémoire, aide à réguler la tension artérielle et soulage la constipation.",
    bienfait_en: "Strengthens bones, supports memory, helps regulate blood pressure and relieves constipation.",
    detail_fr: "Les graines de lin et de sésame trempées sont riches en calcium, oméga-3 et fibres solubles. Le trempage d'au moins 1h est important : il libère les mucilages qui facilitent le transit et rend les nutriments plus assimilables par le corps.",
    detail_en: "Soaked flax and sesame seeds are rich in calcium, omega-3 and soluble fiber. Soaking for at least 1h matters: it releases mucilage that eases digestion and makes nutrients more absorbable.",
    nutrients: ["Calcium", "Oméga-3", "Fibres solubles"],
    categorie: "cerveau",
    couleur: "#22d3ee",
    preparation_fr: "Fais tremper 1 c. à soupe de graines de lin + 1 c. à soupe de graines de sésame dans l'eau pendant au moins 1h. Mixer avec un peu d'eau ou de lait végétal + 1 c. à café de miel. Boire le matin.",
    preparation_en: "Soak 1 tbsp flaxseed + 1 tbsp sesame seeds in water for at least 1h. Blend with a bit of water or plant milk + 1 tsp honey. Drink in the morning.",
    tibb_fr: "Les graines et le miel sont cités ensemble dans la tradition comme aliments nourrissants pour le corps.",
    tibb_en: "Seeds and honey are cited together in tradition as nourishing foods for the body.",
  },
  {
    id: 12,
    emoji: "🌿🧂",
    ingredients: ["Clou de girofle", "Sel", "Alcool à 70°"],
    titre_fr: "Spray Pieds Frais & Anti-Lourdeur",
    titre_en: "Fresh Feet & Anti-Heaviness Spray",
    bienfait_fr: "Rafraîchit les pieds fatigués et lourds, aide à neutraliser les odeurs. Usage externe uniquement.",
    bienfait_en: "Refreshes tired, heavy feet and helps neutralize odor. External use only.",
    detail_fr: "Le clou de girofle contient de l'eugénol, reconnu pour son effet rafraîchissant et antiseptique sur la peau. Le sel apaise, et l'alcool à 70° assure la conservation du mélange et un effet rafraîchissant immédiat.",
    detail_en: "Clove contains eugenol, known for its cooling and antiseptic effect on skin. Salt soothes, and 70° alcohol preserves the mixture and gives an immediate cooling effect.",
    nutrients: ["Eugénol", "Minéraux"],
    categorie: "drainage",
    couleur: "#a3e635",
    preparation_fr: "Dans un petit vaporisateur, mets une poignée de clous de girofle + 1 c. à café de sel + de l'alcool à 70° jusqu'à recouvrir. Laisse infuser quelques jours. Vaporise sur les pieds propres et secs pour soulager la lourdeur.",
    preparation_en: "In a small spray bottle, add a handful of whole cloves + 1 tsp salt + 70° rubbing alcohol to cover. Let infuse a few days. Spray on clean dry feet to relieve heaviness.",
    tibb_fr: "L'hygiène et le soin du corps, y compris des pieds, tiennent une place importante dans la pratique prophétique (wudhu).",
    tibb_en: "Body care and hygiene, including feet, hold an important place in prophetic practice (wudhu).",
    attention_fr: "Usage externe strictement. Ne pas appliquer sur peau lésée. Tenir hors de portée des enfants (contient de l'alcool).",
    attention_en: "Strictly external use. Do not apply on broken skin. Keep out of reach of children (contains alcohol).",
  },
  {
    id: 13,
    emoji: "🥛🌰",
    ingredients: ["Lait", "Pistaches"],
    titre_fr: "Os & Minéraux",
    titre_en: "Bones & Minerals",
    bienfait_fr: "Renforce les os et apporte des minéraux essentiels.",
    bienfait_en: "Strengthens bones and provides essential minerals.",
    detail_fr: "Le calcium du lait associé au magnésium et au phosphore des pistaches soutient la densité osseuse sur le long terme.",
    detail_en: "Calcium from milk combined with magnesium and phosphorus from pistachios supports long-term bone density.",
    nutrients: ["Calcium", "Magnésium", "Phosphore"],
    categorie: "mineraux",
    couleur: "#93c5fd",
    preparation_fr: "Boire 250ml de lait chaud avec une poignée de pistaches non salées en collation du soir.",
    preparation_en: "Drink 250ml warm milk with a handful of unsalted pistachios as an evening snack.",
    tibb_fr: "Le lait est mentionné dans la Sunnah comme une boisson complète et bénie.",
    tibb_en: "Milk is mentioned in the Sunnah as a complete and blessed drink.",
  },
  {
    id: 14,
    emoji: "🥒🥥",
    ingredients: ["Concombre", "Eau de coco"],
    titre_fr: "Reins & Hydratation",
    titre_en: "Kidneys & Hydration",
    bienfait_fr: "Favorise l'élimination rénale et une hydratation profonde.",
    bienfait_en: "Supports kidney function and deep hydration.",
    detail_fr: "Le concombre est riche en eau et en potassium, l'eau de coco apporte des électrolytes naturels qui soulagent le travail des reins.",
    detail_en: "Cucumber is rich in water and potassium, coconut water provides natural electrolytes that ease kidney workload.",
    nutrients: ["Potassium", "Électrolytes", "Eau"],
    categorie: "drainage",
    couleur: "#5eead4",
    preparation_fr: "Mixer 1/2 concombre + 200ml d'eau de coco. Boire frais dans la journée.",
    preparation_en: "Blend 1/2 cucumber + 200ml coconut water. Drink fresh during the day.",
    tibb_fr: "Boire suffisamment d'eau est une recommandation constante dans la tradition prophétique pour la santé du corps.",
    tibb_en: "Drinking enough water is a constant recommendation in prophetic tradition for the body's health.",
  },
  {
    id: 15,
    emoji: "🥚🌿",
    ingredients: ["Œuf", "Épinard"],
    titre_fr: "Vue & Lutéine",
    titre_en: "Vision & Lutein",
    bienfait_fr: "Protège la rétine et soutient une bonne vision nocturne.",
    bienfait_en: "Protects the retina and supports good night vision.",
    detail_fr: "La lutéine et la zéaxanthine de l'épinard, combinées aux protéines et à la vitamine A de l'œuf, protègent la macula.",
    detail_en: "Lutein and zeaxanthin from spinach, combined with protein and vitamin A from egg, protect the macula.",
    nutrients: ["Lutéine", "Vit. A", "Protéines"],
    categorie: "vue",
    couleur: "#f97316",
    preparation_fr: "Omelette : 2 œufs + 1 poignée d'épinards frais sautés. Consommer au petit-déjeuner.",
    preparation_en: "Omelette: 2 eggs + 1 handful of sautéed fresh spinach. Eat for breakfast.",
    tibb_fr: "L'œuf est cité parmi les aliments nourrissants recommandés pour la vitalité du corps.",
    tibb_en: "Egg is cited among the nourishing foods recommended for the body's vitality.",
  },
  {
    id: 16,
    emoji: "🍫🌰",
    ingredients: ["Chocolat noir", "Amandes"],
    titre_fr: "Concentration & Mémoire",
    titre_en: "Focus & Memory",
    bienfait_fr: "Stimule la concentration et soutient la mémoire à long terme.",
    bienfait_en: "Boosts focus and supports long-term memory.",
    detail_fr: "Les flavonoïdes du cacao améliorent le flux sanguin cérébral, la vitamine E des amandes protège les neurones du stress oxydatif.",
    detail_en: "Cocoa flavonoids improve cerebral blood flow, while vitamin E from almonds protects neurons from oxidative stress.",
    nutrients: ["Flavonoïdes", "Vit. E", "Magnésium"],
    categorie: "cerveau",
    couleur: "#a78bfa",
    preparation_fr: "2 carrés de chocolat noir 70%+ avec une poignée d'amandes, en collation avant une session de travail.",
    preparation_en: "2 squares of 70%+ dark chocolate with a handful of almonds, as a snack before a work session.",
    tibb_fr: "Les amandes font partie des fruits secs traditionnellement consommés pour la vigueur du corps et de l'esprit.",
    tibb_en: "Almonds are part of the dried fruits traditionally eaten for the vigor of body and mind.",
  },
  {
    id: 17,
    emoji: "🥣🌾",
    ingredients: ["Avoine", "Graines de lin"],
    titre_fr: "Cœur & Cholestérol",
    titre_en: "Heart & Cholesterol",
    bienfait_fr: "Aide à réduire le mauvais cholestérol et soutient la santé cardiaque.",
    bienfait_en: "Helps lower bad cholesterol and supports heart health.",
    detail_fr: "Les bêta-glucanes de l'avoine captent le cholestérol dans l'intestin, les oméga-3 des graines de lin réduisent l'inflammation artérielle.",
    detail_en: "Beta-glucans in oats trap cholesterol in the gut, omega-3s in flax seeds reduce arterial inflammation.",
    nutrients: ["Bêta-glucanes", "Oméga-3", "Fibres"],
    categorie: "coeur",
    couleur: "#f87171",
    preparation_fr: "Bol de flocons d'avoine + 1 c. à soupe de graines de lin moulues, au petit-déjeuner.",
    preparation_en: "Bowl of oats + 1 tbsp ground flax seeds, for breakfast.",
    tibb_fr: "La modération alimentaire, y compris pour le cœur, est un principe central de la Sunnah.",
    tibb_en: "Dietary moderation, including for the heart, is a central principle of the Sunnah.",
  },
  {
    id: 18,
    emoji: "🫚🍵",
    ingredients: ["Curcuma", "Thé vert"],
    titre_fr: "Foie & Détox",
    titre_en: "Liver & Detox",
    bienfait_fr: "Soutient la fonction hépatique et aide à l'élimination des toxines.",
    bienfait_en: "Supports liver function and helps eliminate toxins.",
    detail_fr: "La curcumine stimule la production de bile, les catéchines du thé vert protègent les cellules du foie du stress oxydatif.",
    detail_en: "Curcumin stimulates bile production, green tea catechins protect liver cells from oxidative stress.",
    nutrients: ["Curcumine", "Catéchines", "Antioxydants"],
    categorie: "drainage",
    couleur: "#5eead4",
    preparation_fr: "Infuser du thé vert avec 1/2 c. à café de curcuma + une pincée de poivre noir. Boire après le repas.",
    preparation_en: "Steep green tea with 1/2 tsp turmeric + a pinch of black pepper. Drink after meals.",
    tibb_fr: "Le curcuma est traditionnellement utilisé dans la médecine naturelle pour purifier le corps.",
    tibb_en: "Turmeric is traditionally used in natural medicine to purify the body.",
  },
  {
    id: 19,
    emoji: "🌴🍯",
    ingredients: ["Dattes Medjool", "Lait", "Miel", "Cannelle"],
    titre_fr: "Smoothie Vitalité Dorée",
    titre_en: "Golden Vitality Smoothie",
    bienfait_fr: "Boost d'énergie durable et soutien de la vitalité masculine.",
    bienfait_en: "Long-lasting energy boost and support for male vitality.",
    detail_fr: "Les dattes apportent des sucres naturels à libération lente et du zinc, le miel brut ajoute des enzymes actives, la cannelle stimule la circulation.",
    detail_en: "Dates provide slow-release natural sugars and zinc, raw honey adds active enzymes, cinnamon stimulates circulation.",
    nutrients: ["Zinc", "Potassium", "Enzymes actives"],
    categorie: "fertilite",
    couleur: "#fbbf24",
    preparation_fr: "Mixer 3 dattes dénoyautées + 250ml de lait + 1 c. à café de miel + une pincée de cannelle. Boire le matin.",
    preparation_en: "Blend 3 pitted dates + 250ml milk + 1 tsp honey + a pinch of cinnamon. Drink in the morning.",
    tibb_fr: "Le miel est cité dans le Coran (16:69) comme une guérison pour les gens, et les dattes faisaient partie de l'alimentation quotidienne du Prophète ﷺ.",
    tibb_en: "Honey is mentioned in the Quran (16:69) as a healing for people, and dates were part of the Prophet's ﷺ daily diet.",
  },
  {
    id: 20,
    emoji: "🌴🌰",
    ingredients: ["Dattes", "Noix", "Graines de sésame"],
    titre_fr: "Boules Énergie Fertilité",
    titre_en: "Fertility Energy Balls",
    bienfait_fr: "Snack dense en nutriments pour soutenir la qualité et la production reproductive.",
    bienfait_en: "Nutrient-dense snack to support reproductive quality and production.",
    detail_fr: "Les oméga-3 des noix, le zinc des graines de sésame et l'énergie des dattes forment une base nutritionnelle complète pour la santé reproductive masculine.",
    detail_en: "Omega-3s from walnuts, zinc from sesame seeds, and energy from dates form a complete nutritional base for male reproductive health.",
    nutrients: ["Oméga-3", "Zinc", "Fibres"],
    categorie: "fertilite",
    couleur: "#fbbf24",
    preparation_fr: "Mixer 10 dattes dénoyautées + une poignée de noix jusqu'à obtenir une pâte. Former des petites boules et rouler dans les graines de sésame. Se conserve 1 semaine au frigo.",
    preparation_en: "Blend 10 pitted dates + a handful of walnuts into a paste. Roll into small balls and coat in sesame seeds. Keeps 1 week in the fridge.",
    tibb_fr: "Les noix et fruits secs sont recommandés dans la tradition prophétique pour la force du corps.",
    tibb_en: "Nuts and dried fruits are recommended in prophetic tradition for the body's strength.",
    attention_fr: "Pour de meilleurs résultats, évite aussi les boissons gazeuses, les bains très chauds prolongés et le téléphone dans la poche avant — des facteurs qui nuisent à la santé reproductive.",
    attention_en: "For best results, also avoid soda drinks, prolonged very hot baths, and keeping your phone in your front pocket — factors that harm reproductive health.",
  },
  {
    id: 21,
    emoji: "🧄🍅",
    ingredients: ["Ail", "Tomates"],
    titre_fr: "Protection & Mobilité",
    titre_en: "Protection & Mobility",
    bienfait_fr: "Protège les cellules reproductives et soutient leur mobilité.",
    bienfait_en: "Protects reproductive cells and supports their mobility.",
    detail_fr: "L'allicine de l'ail améliore la circulation sanguine locale, le lycopène de la tomate protège contre le stress oxydatif.",
    detail_en: "Allicin in garlic improves local blood circulation, lycopene in tomato protects against oxidative stress.",
    nutrients: ["Allicine", "Lycopène", "Vit. C"],
    categorie: "fertilite",
    couleur: "#fbbf24",
    preparation_fr: "1 gousse d'ail crue hachée dans une salade de tomates fraîches, 2-3 fois par semaine.",
    preparation_en: "1 chopped raw garlic clove in a fresh tomato salad, 2-3 times a week.",
    tibb_fr: "L'ail est mentionné parmi les plantes aux vertus reconnues dans la médecine traditionnelle.",
    tibb_en: "Garlic is mentioned among the plants with recognized virtues in traditional medicine.",
  },
  {
    id: 22,
    emoji: "🐟🍋",
    ingredients: ["Saumon", "Citron"],
    titre_fr: "Résistance & Énergie",
    titre_en: "Resistance & Energy",
    bienfait_fr: "Renforce la résistance physique et l'énergie reproductive.",
    bienfait_en: "Strengthens physical resistance and reproductive energy.",
    detail_fr: "Les oméga-3 du saumon soutiennent la circulation, la vitamine C du citron améliore l'absorption des nutriments essentiels.",
    detail_en: "Omega-3s from salmon support circulation, vitamin C from lemon improves absorption of essential nutrients.",
    nutrients: ["Oméga-3", "Vit. C", "Vit. D"],
    categorie: "fertilite",
    couleur: "#fbbf24",
    preparation_fr: "Filet de saumon grillé arrosé de jus de citron frais, 2 fois par semaine.",
    preparation_en: "Grilled salmon fillet drizzled with fresh lemon juice, twice a week.",
    tibb_fr: "Le poisson est mentionné parmi les nourritures licites et bénéfiques.",
    tibb_en: "Fish is mentioned among the lawful and beneficial foods.",
  },
  {
    id: 23,
    emoji: "🥒🫚",
    ingredients: ["Concombre", "Cannelle"],
    titre_fr: "Ventre Plat & Glycémie",
    titre_en: "Flat Belly & Blood Sugar",
    bienfait_fr: "Réduit les ballonnements et aide à stabiliser la glycémie.",
    bienfait_en: "Reduces bloating and helps stabilize blood sugar.",
    detail_fr: "Le concombre draine l'excès d'eau, la cannelle améliore la sensibilité à l'insuline et limite le stockage abdominal.",
    detail_en: "Cucumber drains excess water, cinnamon improves insulin sensitivity and limits abdominal storage.",
    nutrients: ["Eau", "Cinnamaldéhyde", "Fibres"],
    categorie: "glycemie",
    couleur: "#a3e635",
    preparation_fr: "Eau infusée : tranches de concombre + 1 bâton de cannelle dans 500ml d'eau, toute la journée.",
    preparation_en: "Infused water: cucumber slices + 1 cinnamon stick in 500ml water, throughout the day.",
    tibb_fr: "L'équilibre alimentaire est encouragé pour préserver la santé du corps sur le long terme.",
    tibb_en: "Dietary balance is encouraged to preserve the body's health long-term.",
  },
  {
    id: 24,
    emoji: "🌰🌿",
    ingredients: ["Noix", "Épinard"],
    titre_fr: "Anémie & Cholestérol",
    titre_en: "Anemia & Cholesterol",
    bienfait_fr: "Aide à combattre l'anémie et à réguler le cholestérol.",
    bienfait_en: "Helps fight anemia and regulate cholesterol.",
    detail_fr: "Le fer de l'épinard combat l'anémie, les acides gras des noix aident à réguler le taux de cholestérol sanguin.",
    detail_en: "Iron from spinach fights anemia, fatty acids from walnuts help regulate blood cholesterol levels.",
    nutrients: ["Fer", "Oméga-3", "Folates"],
    categorie: "energie",
    couleur: "#00ff88",
    preparation_fr: "Salade d'épinards frais + une poignée de noix concassées, en accompagnement du repas.",
    preparation_en: "Fresh spinach salad + a handful of crushed walnuts, as a side to your meal.",
    tibb_fr: "Les légumes verts feuillus sont valorisés dans la tradition prophétique pour la vitalité.",
    tibb_en: "Leafy green vegetables are valued in prophetic tradition for vitality.",
  },
  {
    id: 25,
    emoji: "🫚🌾",
    ingredients: ["Gingembre", "Graines de fenouil"],
    titre_fr: "Anti-ballonnement",
    titre_en: "Anti-bloating",
    bienfait_fr: "Soulage rapidement les ballonnements et l'inconfort digestif.",
    bienfait_en: "Quickly relieves bloating and digestive discomfort.",
    detail_fr: "Le gingembre stimule la vidange gastrique, les graines de fenouil détendent les muscles intestinaux et réduisent les gaz.",
    detail_en: "Ginger stimulates gastric emptying, fennel seeds relax intestinal muscles and reduce gas.",
    nutrients: ["Gingérols", "Anéthol", "Fibres"],
    categorie: "digestion",
    couleur: "#fbbf24",
    preparation_fr: "Infusion : 1 cm de gingembre frais + 1 c. à café de graines de fenouil dans de l'eau chaude, après le repas.",
    preparation_en: "Infusion: 1 cm fresh ginger + 1 tsp fennel seeds in hot water, after meals.",
    tibb_fr: "Le gingembre est cité dans le Coran (76:17) et recommandé pour la digestion.",
    tibb_en: "Ginger is mentioned in the Quran (76:17) and recommended for digestion.",
  },
  {
    id: 26,
    emoji: "🌿🍋",
    ingredients: ["Menthe fraîche", "Citron"],
    titre_fr: "Tisane Digestive du Maghreb",
    titre_en: "Maghreb Digestive Tea",
    bienfait_fr: "Apaise les inconforts digestifs après le repas et rafraîchit l'haleine.",
    bienfait_en: "Soothes post-meal digestive discomfort and freshens breath.",
    detail_fr: "Le menthol de la menthe détend les muscles digestifs et facilite le transit, la vitamine C du citron soutient la digestion des graisses.",
    detail_en: "Menthol in mint relaxes digestive muscles and eases transit, vitamin C from lemon supports fat digestion.",
    nutrients: ["Menthol", "Vit. C", "Antioxydants"],
    categorie: "digestion",
    couleur: "#22c55e",
    preparation_fr: "Infuser une poignée de feuilles de menthe fraîche dans de l'eau chaude 5 min, ajouter le jus d'1/2 citron. Boire après le repas.",
    preparation_en: "Steep a handful of fresh mint leaves in hot water for 5 min, add the juice of 1/2 lemon. Drink after meals.",
    tibb_fr: "Le thé à la menthe fait partie des traditions d'hospitalité et de bien-être digestif au Maghreb.",
    tibb_en: "Mint tea is part of the hospitality and digestive wellness traditions in the Maghreb.",
  },
  {
    id: 27,
    emoji: "🍉🥒",
    ingredients: ["Pastèque", "Concombre"],
    titre_fr: "Hydratation Profonde",
    titre_en: "Deep Hydration",
    bienfait_fr: "Hydrate en profondeur et soutient le travail des reins.",
    bienfait_en: "Deeply hydrates and supports kidney function.",
    detail_fr: "Ces deux aliments sont composés à plus de 90% d'eau et apportent des électrolytes qui facilitent la filtration rénale.",
    detail_en: "Both foods are over 90% water and provide electrolytes that ease kidney filtration.",
    nutrients: ["Eau", "Citrulline", "Potassium"],
    categorie: "drainage",
    couleur: "#5eead4",
    preparation_fr: "Mixer des cubes de pastèque + 1/2 concombre. Boire frais en journée chaude.",
    preparation_en: "Blend watermelon cubes + 1/2 cucumber. Drink fresh on a hot day.",
    tibb_fr: "S'hydrater suffisamment est une pratique encouragée pour préserver la santé du corps.",
    tibb_en: "Staying properly hydrated is an encouraged practice to preserve the body's health.",
  },
  {
    id: 28,
    emoji: "🌿🍋",
    ingredients: ["Persil frais", "Citron"],
    titre_fr: "Détox Foie & Vitamine C",
    titre_en: "Liver Detox & Vitamin C",
    bienfait_fr: "Soutient la détoxification du foie et renforce l'immunité.",
    bienfait_en: "Supports liver detoxification and strengthens immunity.",
    detail_fr: "Le persil est riche en vitamine C et en chlorophylle, il stimule l'élimination rénale et hépatique. Le citron amplifie cet effet détoxifiant.",
    detail_en: "Parsley is rich in vitamin C and chlorophyll, it stimulates kidney and liver elimination. Lemon amplifies this detoxifying effect.",
    nutrients: ["Vit. C", "Chlorophylle", "Antioxydants"],
    categorie: "drainage",
    couleur: "#5eead4",
    preparation_fr: "Mixer une grosse poignée de persil frais + jus d'un citron + 200ml d'eau. Filtrer et boire le matin à jeun.",
    preparation_en: "Blend a large handful of fresh parsley + juice of 1 lemon + 200ml water. Strain and drink in the morning on an empty stomach.",
    tibb_fr: "Les herbes fraîches et les fruits acidulés sont valorisés dans la médecine traditionnelle pour purifier le corps.",
    tibb_en: "Fresh herbs and tart fruits are valued in traditional medicine to purify the body.",
  },
];

// Catégories valides (doivent correspondre exactement aux valeurs
// que l'IA peut renvoyer dans "categorie_recette" pour chaque scan)
export const CATEGORIES_RECETTES = [
  "vue", "digestion", "coeur", "energie", "immunite",
  "drainage", "glycemie", "cerveau", "mineraux", "fertilite"
];

// Retourne UNE recette correspondant à une catégorie donnée.
// Si plusieurs recettes existent pour la catégorie, en choisit une au hasard
// (pour varier les suggestions d'une fois à l'autre).
export function getRecetteParCategorie(categorie) {
  const matches = RECETTES.filter(r => r.categorie === categorie);
  if (matches.length === 0) return null;
  return matches[Math.floor(Math.random() * matches.length)];
}
